import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { DTypeFormSmileysField } from '@grupo-constant/next-dtype/form';
import { DTypeFormFieldComponent } from '../../dtype-field.model';

@Component({
    selector: 'smileys-field-component',
    templateUrl: './smileys-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButtonModule, MatIconModule]
})
export class DtypeSmileysFieldComponent implements DTypeFormFieldComponent, OnInit {

    @Input() field: DTypeFormSmileysField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    emojisValue: {emoji: string; marked: boolean}[];
    value: string;

    constructor(
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer
    ) {
        this.matIconRegistry.addSvgIcon('emoji-sad-outline', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/emoji-sad-outline.svg'));
        this.matIconRegistry.addSvgIcon('emoji-sad-solid', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/emoji-sad-solid.svg'));
        this.matIconRegistry.addSvgIcon('emoji-happy-outline', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/emoji-happy-outline.svg'));
        this.matIconRegistry.addSvgIcon('emoji-happy-solid', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/emoji-happy-solid.svg'));
        this.matIconRegistry.addSvgIcon('emoji-none-outline', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/emoji-none-outline.svg'));
        this.matIconRegistry.addSvgIcon('emoji-none-solid', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/emoji-none-solid.svg'));
    }

    ngOnInit() {
        this.emojisValue = [{emoji: 'H', marked: false}, {emoji: 'N', marked: false}, {emoji: 'S', marked: false}];
        if (this.field.direction === 'END') {
            this.emojisValue.reverse();
        }
        if (this.field.control.value !== undefined) {
            const val = this.emojisValue.find(e => e.emoji === this.field.control.value);
            this.markEmoji(val);
        }
        this.value = this.field.control.value ? this.field.control.value : undefined;
        this.field.control.valueChanges.subscribe((value) => {
            this.value = value;
            if (this.value === undefined) {
                this.field.control.setErrors({ 'incorrect': true });
            }
        });
    }

    markEmoji(value: any) {
        const valMarked = this.emojisValue.find(e => e.emoji === value.emoji);
        if (this.value !== undefined) {
            if (value.emoji === this.value) {
                this.field.control.setValue(undefined);
                valMarked.marked = false;
            } else {
                const val = this.emojisValue.find(e => e.emoji === this.value);
                val.marked = false;
                valMarked.marked = true;
                this.field.control.setValue(value.emoji);
            }
        } else {
            valMarked.marked = true;
            this.field.control.setValue(value.emoji);
        }
    }
}

